module.exports = __webpack_public_path__ + "sr.38ed742d4434061fc487.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sr.svg
// module chunks = styles